"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _SecretTree = _interopRequireDefault(require("./SecretTree"));

var _action = require("./action");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$vaultLanding, _state$userSecretsRed2, _state$userSecretsRed3;

  var _state$vaultLanding$d = state === null || state === void 0 ? void 0 : (_state$vaultLanding = state.vaultLanding) === null || _state$vaultLanding === void 0 ? void 0 : _state$vaultLanding.data,
      vaultName = _state$vaultLanding$d.name;

  var _state$userSecretsRed = state === null || state === void 0 ? void 0 : (_state$userSecretsRed2 = state.userSecretsReducer) === null || _state$userSecretsRed2 === void 0 ? void 0 : (_state$userSecretsRed3 = _state$userSecretsRed2.allSecretsReducer) === null || _state$userSecretsRed3 === void 0 ? void 0 : _state$userSecretsRed3.getImmediateNodes,
      immediateNodes = _state$userSecretsRed.result;

  return {
    vaultName: vaultName,
    immediateNodes: immediateNodes,
    parentsOfSelectedItem: ownProps.parentsOfSelectedItem
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    selectionHandler: ownProps.selectionHandler,
    getImmediateNodes: function getImmediateNodes(parents) {
      return dispatch((0, _action.requestGetImmediateNodes)(parents));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SecretTree.default);

exports.default = _default;